import React from 'react';
import { useNavigate } from 'react-router';

import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';


const useStyles = makeStyles(theme => ({}));

const SupportFileHash = () => {
    const classes = useStyles();
    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-1);
    };

    return (
        <main>
            {/* <Box display="flex" justifyContent="flex-end" width="100%">
                <Button color="primary" variant="contained" onClick={handleBack}>Back</Button>
            </Box> */}
            <Typography variant="h3">File MD5 Hash Config Reference</Typography>
            <Paper elevation={3}>
                <Box p={3} mt={2}>
                    <Typography>Configure URL(s) to fetch MD5 list(file) from.</Typography>
                    <Typography>Only text files with .txt or .md5 extension are considered valid.</Typography>
                    <Typography>Only one MD5 per line is accepted.</Typography>
                    <Typography>Valid line must begin with an MD5, followed by a new line or a space character. Any text on that line after space is ignored.</Typography>
                    <Typography>Lines beginning with space or '#' character are ignored.</Typography>
                </Box>
            </Paper>
            <Paper elevation={3}>
                <Box p={3} mt={2}>
                    <Typography>Valid URL format examples (username, password and port are required only where applicable):</Typography>
                    <Typography><code>http://host/file.txt</code></Typography>
                    <Typography><code>http://username:password@host:port/dir/file.txt</code></Typography>

                    <Typography><code>https://host/file.txt</code></Typography>
                    <Typography><code>https://host/dir/file.txt</code></Typography>
                    <Typography><code>https://username:password@host:port/dir/file.txt</code></Typography>

                    <Typography><code>scp://username:password@host:port/dir/file.txt</code></Typography>
                </Box>
            </Paper>
        </main>
    );
};

export default SupportFileHash;
